import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { WhereToBuyComponent } from './where-to-buy/where-to-buy.component';
import { SendWishListToDealerComponent } from './send-wish-list-to-dealer/send-wish-list-to-dealer.component';
import { RedirectLocaleComponent } from './redirect-locale/redirect-locale.component';

const routes: Routes = [

    {
        path: ':lang/send-wish-list-to-dealer',
        component: SendWishListToDealerComponent,
        // data: { title: 'Heroes List' }
    },
    {
      path: 'it',
      component: WhereToBuyComponent,
      data: { 'language': 'IT'},
      pathMatch: 'prefix'
    },
    {
      path: 'es',
      component: WhereToBuyComponent,
      data: { 'language': 'ES'},
      pathMatch: 'prefix'
    },
    {
      path: 'hu',
      component: WhereToBuyComponent,
      data: { 'language': 'HU'},
      pathMatch: 'prefix'
    },
    {
      path: 'fr',
      component: WhereToBuyComponent,
      data: { 'language': 'FR'},
      pathMatch: 'prefix'
    },
    {
      path: 'nl',
      component: WhereToBuyComponent,
      data: { 'language': 'NL'},
      pathMatch: 'prefix'
    },
    {
      path: 'en',
      component: WhereToBuyComponent,
      data: { 'language': 'EN'},
      pathMatch: 'prefix'
    },
    {
      path: 'uk', //path per filiale inglese
      component: WhereToBuyComponent,
      data: { 'language': 'UK'},
      pathMatch: 'prefix'
    },
    {
      path: 'de',
      component: WhereToBuyComponent,
      data: { 'language': 'DE'},
      pathMatch: 'prefix'
    },
    {
      path: 'at',
      component: WhereToBuyComponent,
      data: { 'language': 'AT'},
      pathMatch: 'prefix'
    },
    {
      path: '',
      component: RedirectLocaleComponent,
      pathMatch: 'full'
    },
    { path: '**', redirectTo: '/' }
];


@NgModule({
    imports: [RouterModule.forRoot(routes) ], // .forRoot(routes, { enableTracing: true })
    exports: [RouterModule]
})
export class AppRoutingModule { }



// WEBPACK FOOTER //
// ./src/app/app-routing.module.ts